import { RootState } from '../store'

export const selectSelectedAols = (state: RootState): string[] | undefined => {
  return state.legislation.selectedAols
}
